<template>
  <div class="container is-max-desktop">

    <app-header></app-header>
    <Payload v-for="payload in payloads" :payload="payload" :key="payload"></Payload>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader';
import AppFooter from '@/components/AppFooter';
import Payload from "@/components/Payload";

export default {
  name: 'App',
  components: {
    Payload,
    AppHeader,
    AppFooter
  },
  data() {
    return {
      payloads: null
    };
  },
  async created() {
    const response = await fetch("/api/cloudflare");
    this.payloads = await response.json();
  }
}
</script>

<style lang="scss">
</style>
